// export const baseApiCore='http://127.0.0.1:8080/api/'
export const baseApiCore='http://khorshidpishva.com:8080/api/'
// export const baseApi='http://127.0.0.1:8080/api/site/';
export const baseApi='http://khorshidpishva.com:8080/api/site/';
export const fileManager=`${baseApiCore}fileManager/`;
